import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import Battery0BarIcon from '@mui/icons-material/Battery0Bar'
import Battery1BarIcon from '@mui/icons-material/Battery1Bar'
import Battery2BarIcon from '@mui/icons-material/Battery2Bar'
import Battery3BarIcon from '@mui/icons-material/Battery3Bar'
import Battery4BarIcon from '@mui/icons-material/Battery4Bar'
import Battery5BarIcon from '@mui/icons-material/Battery5Bar'
import Battery6BarIcon from '@mui/icons-material/Battery6Bar'
import BatteryFullIcon from '@mui/icons-material/BatteryFull'
import {
    ListItemButton,
    Stack,
} from '@mui/material'
import { decimalFormat, imgProxy } from 'src/lib/util'
import { brezavta_api__models__micromobility__Vehicle as MicromobilityVehicleType } from 'src/generated/brezavta/requests/types.gen'

const MicromobilityVehicle = ({ item }: { item: MicromobilityVehicleType }) => {
    return (
        <ListItemButton
            style={{ display: 'flex', gap: 5 }}
            {...(item.deeplink
                ? { component: 'a', href: item.deeplink, target: '_blank', rel: 'noopener noreferrer' }
                : {}
            )}
        >
            <img
                src={imgProxy(item.image_url ?? '')}
                width="70px"
                style={{ objectFit: 'contain' }}
            />
            <Stack direction="column" spacing={1} style={{ flexGrow: 1 }}>
                {item.model}
                <Stack direction="column" style={{ fontSize: '.8em' }}>
                    <Stack direction="row" gap={1}>
                        {(item.price_per_km && (
                            <span>
                                {decimalFormat(item.price_per_km)}
                                &nbsp;€/km
                            </span>
                        ))}
                        {(item.price_per_min && (
                            <span>
                                {decimalFormat(item.price_per_min)}
                                &nbsp;€/min
                            </span>
                        ))}

                        <span>
                            {item.price_start && `Start: ${item.price_start} €`}
                            {item.price_minimum && `Min: ${item.price_minimum} €`}
                        </span>
                    </Stack>
                </Stack>
            </Stack>
            <Stack direction="column" style={{ fontSize: '.8em' }}>
                {item.battery != null && (
                    <Stack direction="row" style={{ justifyContent: 'right' }}>
                        {item.battery}
                        &nbsp;%
                    </Stack>
                )}
                {item.range != null && (
                    <Stack direction="row" style={{ justifyContent: 'right' }}>
                        {item.range}
                        &nbsp;km
                    </Stack>
                )}
            </Stack>
            {batteryIcon(item)}
            {item.deeplink && (
                <ChevronRightIcon />
            )}
        </ListItemButton>
    )
}

/**
 * Select the appropriate MUI battery icon based on the battery level of the vehicle (0-6 or full).
 */
function batteryIcon(item: MicromobilityVehicleType) {
    if (item.battery == null)
        return null
    if (item.battery == 100)
        return <BatteryFullIcon />
    if (item.battery >= 95)
        return <Battery6BarIcon />
    if (item.battery >= 80)
        return <Battery5BarIcon />
    if (item.battery >= 65)
        return <Battery4BarIcon />
    if (item.battery >= 50)
        return <Battery3BarIcon />
    if (item.battery >= 35)
        return <Battery2BarIcon />
    if (item.battery >= 20)
        return <Battery1BarIcon />
    return <Battery0BarIcon />
}

export default MicromobilityVehicle
